<template>
  <div name="hrms-dropzone">
    <div v-show="maxNumberOfFiles > 0">
      <div v-show="disabled" >
        Upload Here
      </div>
      <vue-dropzone  v-show="!disabled"
                    :id="name"
                    :url="url"
                    :headers="headers"
                    :useFontAwesome="true"
                    @vdropzone-sending="validateFileName"
                    @vdropzone-removed-file="postDeleteFile"
                    @vdropzone-success="addFileTemp"
                    @vdropzone-error="triggerError"
                    :maxNumberOfFiles="maxNumberOfFiles"
                    :showRemoveLink="showRemoveLink"
                    :maxFileSizeInMB="maxFileSizeInMB"
                    :acceptedFileTypes="acceptedFileTypes"
                    ref="vueDropzoneMultiCall"
                    :class="{ 'input-error' : hasError }"  >
        <input type="hidden" name="token" value="xxx">
        <div class="text-remark _text-blue">
          <ul>
            <li>File name must only contain alphanumeric characters with no spaces and hiphen.</li>
            <li>Maximum size of 2 MB is allowed.</li>
            <li>Maximum {{maxNumberOfFiles}} files.</li>
          </ul>
        </div>
      </vue-dropzone>
    </div>
    <div v-for="(file, index) in fileOutPut" :key="index">
      <label v-show="!dispAttach && file.status === ''">{{ file.fileName }}
        <a class="fa fa-paperclip ico-knowledge1 dash-color-skin"
          :href="filePath + file.fileName"
          target="_blank" v-show="filePath + file.fileName"
          @click.stop>
        </a>
        <a class="fa fa-trash ico-knowledge1 cursor-pointer"
          v-show="filePath + file.fileName"
          @click="deleteFileTemp(file.fileName)">
        </a>
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as types from 'store/modules/hrmsDropzone/mutation-types'
import vueDropzone from 'vue2-dropzone'
import env from 'src/../env.js'

const configLabels = require('src/../config/label')

export default {
  name: 'hrms-dropzone',
  data () {
    return {
      dash: this.$root.$children[0].$children[0],
      url: window.localStorage.getItem(env.site + '_baseURL') + 'api/uploader/uploadFile',
      headers: {
        currentUser: this.getCurrentUser(),
        fileDir: this.fileDir
      },
      filePath: '',
      fileDir: '',
      flgSave: false,
      fileOutPut: [],
      dispAttach: true,
      flgLoadSuccess: true,
      fileStatus: {},
      // inputFileName: '',
      // tempFileName: [],
      // // tempDataFile: [],
      // resultFileName: this.value,
      // flgLoadSuccess: true,
      baseURL: window.localStorage.getItem(env.site + '_baseURL')
    }
  },
  created () {
    this.fileOutPut = this.value
    this.dispAttach = (this.fileOutPut.length === 0)
    this.setupDir()
  },
  computed: {
    getTfolder () {
      let tfolder = this.dash.getTfolder()
      return tfolder
    }
  },
  watch: {
    value () {
      this.fileOutPut = this.value
      this.dispAttach = (this.fileOutPut.length === 0)
    },
    getTfolder () {
      this.setupDir()
    },
    'prefixFileName' () {
      this.headers.currentUser = this.getCurrentUser()
    },
    'flgToggle' () {
      let fileDel = this.fileOutPut
        .filter(dataFilter => (dataFilter.status === 'A'))
        .reduce((sum, dataReduce) => {
          return sum + dataReduce.fileName + '|'
        }, '')
      fileDel = fileDel.substr(0, fileDel.length - 1)
      if (fileDel !== 'undefined' && fileDel !== '') {
        this.postDeleteFile({name: fileDel})
      }
      this.flgSave = true
      this.clearDropzone()
      // this.fileOutPut = []
      this.fileOutPut = this.fileOutPut
        .filter(dataFilter => (dataFilter.status === '' || dataFilter.status === 'D'))
        .map(dataMap => {
          return {fileName: dataMap.fileName, status: ''}
        })
      this.$emit('input', this.fileOutPut)
      this.flgSave = false
    }
  },
  mounted () {
    this.$on('$clearDropzone', () => {
      this.clearDropzone()
    })
    this.$on('$clearFileTemp', () => {
      this.clearFileTemp()
    })
  },
  methods: {
    addFileTemp (file, response) {
      this.fileOutPut.push({fileName: response.file.new_filename ? response.file.new_filename : file.name, oldFileName: file.name, status: 'A'})
      this.flgLoadSuccess = true
      this.$emit('input', this.fileOutPut)
    },
    deleteFileTemp (fileName) {
      let fileIndex = this.fileOutPut.map(file => {
        return file.fileName
      }).indexOf(fileName)
      if (fileIndex > -1) {
        this.fileOutPut[fileIndex].status = 'D'
        this.$emit('input', this.fileOutPut)
        this.$emit('triggerDataFiles')
      }
    },
    postDeleteFile (file) {
      if (!this.flgSave) {
        let files = file
        let fileDel = this.fileOutPut
          .filter(dataFilter => (dataFilter.status === 'A' && dataFilter.oldFileName === file.name))
          .reduce((sum, dataReduce) => {
            return sum + dataReduce.fileName + '|'
          }, '')
        fileDel = fileDel.substr(0, fileDel.length - 1)
        if (fileDel !== 'undefined' && fileDel !== '') {
          files = {name: fileDel}
        }
        this.fileOutPut = this.fileOutPut.filter(dataFilter => (dataFilter.oldFileName !== file.name))
        this.postRemovedFile({ file: files, fileDir: this.headers.fileDir })
        this.$emit('input', this.fileOutPut)
      }
    },
    ...mapActions({
      postRemovedFile: types.POST_HRMS_DROPZONE_REMOVED_FILE
    }),
    removeFileEvent () {
      this.$refs.vueDropzoneMultiCall.removeAllFiles()
    },
    validateFileName (file, xhr, formData) {
    },
    triggerError (file) {
      this.flgLoadSuccess = !(file.status === 'error')
    },
    setupDir () {
      if (!this.othPath) {
        if (this.flgPathTemp || this.getTfolder.codapp === '') {
          this.headers.fileDir = this.getTfolder.temp
        } else {
          // this.headers.fileDir = this.getTfolder.main + this.getTfolder.folder
          this.headers.fileDir = this.getTfolder.folder
        }
        // this.filePath = this.getTfolder.load + this.getTfolder.folder + '/'
        this.filePath = this.baseURL + 'file_uploads/' + this.getTfolder.folder + '/'
      } else {
        this.headers.fileDir = this.othPath
      }
    },
    getCurrentUser () {
      let objCurrentUser = JSON.parse(configLabels.getCurrentUserHeader())
      objCurrentUser.codapp = this.$route.name
      objCurrentUser.flgrename = this.flgRename ? 'Y' : 'N'
      objCurrentUser.codempidQuery = this.prefixFileName
      return JSON.stringify(objCurrentUser)
    },
    callDeleteFile (fileName) {
      let file = {
        name: ''
      }
      file.name = fileName
      this.$nextTick(() => {
        this.postDeleteFile(file)
      })
    },
    clearDropzone () {
      this.$refs.vueDropzoneMultiCall.removeAllFiles()
    },
    clearFileTemp () {
      if (this.fileOutPut) {
        this.callDeleteFile(this.fileOutPut)
      }
    },
    triggerCallSave () {
      let fileDel = this.fileOutPut
        .filter(dataFilter => (dataFilter.status === 'D'))
        .reduce((sum, dataReduce) => {
          return sum + dataReduce.fileName + '|'
        }, '')
      fileDel = fileDel.substr(0, fileDel.length - 1)
      if (fileDel !== 'undefined' && fileDel !== '') {
        this.postDeleteFile({name: fileDel})
      }
      this.fileOutPut = []
    }
  },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    flgPathTemp: {
      type: Boolean,
      default () {
        return false
      }
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1
    },
    showRemoveLink: {
      type: Boolean,
      default: true
    },
    prefixFileName: {
      type: String
    },
    flgRename: {
      type: Boolean,
      default () {
        return true
      }
    },
    flgToggle: {
      type: Boolean,
      default () {
        return false
      }
    },
    othPath: {
      type: String
    },
    maxFileSizeInMB: {
      type: Number
    },
    acceptedFileTypes: {
      type: String
    },
    name: {
      type: String,
      default () {
        return 'vueDropzone'
      }
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vueDropzone
  }
}
</script>

<style>
  .text-remark {
    font-size: 11px;
  }
</style>



// WEBPACK FOOTER //
// component.vue?97660b8e